import React from 'react';

import Image from 'next/image';
import { useTheme } from 'styled-components';

import Tooltip from '@components/ui/Tooltip/next';
import { SubratingViewModel } from '@api/models/SubratingViewModel';
import { Typography } from '@components/Typography/Typography';
import { RatingProviderType } from '@api/index';

import {
  Container,
  ContainerBox,
  ContainerHead,
  DivSpan,
  MainTitle,
  Note,
  NoteWrapper,
  Percent,
  PercentWrapper,
  ScoringLine,
  Separate,
  Span,
  SpanWrapper,
  TooltipContainer,
  TooltipTitle,
  TotalPercent,
  Wrapper,
  TotalContainer,
  WrapperTitle,
} from './styled';
import { getRating, getRatingAboveFour } from '../../scoring/getReviewIcon';
import PointBar from '../../scoring/PointBar';

export type ScoringProps = {
  totalScoring?: number;
  subratings: Array<SubratingViewModel>;
  generalRatingImage?: string;
  provider?: RatingProviderType;
};

const ScoringBanner = ({
  totalScoring,
  subratings,
  generalRatingImage,
  provider,
}: ScoringProps) => {
  const { palette } = useTheme();
  return (
    <Container>
      <Wrapper>
        <Tooltip
          zIndex={1}
          getPopupContainer={(triggerNode) => triggerNode}
          overlayInnerStyle={{
            backgroundColor: palette.white,
            color: palette.darkGray,
            lineHeight: 1.43,
            width: '250px',
            minHeight: '260px',
            marginTop: '0',
            borderRadius: '8px',
            boxShadow:
              '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
          }}
          showArrow={false}
          placement='bottomRight'
          title={
            <>
              <TotalContainer>
                <TooltipTitle>
                  <MainTitle>Genel Toplam</MainTitle>
                </TooltipTitle>
                <ScoringLine>
                  {generalRatingImage ? (
                    <Image
                      src={generalRatingImage ?? ''}
                      alt='playstoreqr'
                      width={60}
                      height={10}
                    />
                  ) : totalScoring ? (
                    <PointBar
                      value={totalScoring || 0}
                      maxValue={5}
                      width='50px'
                    />
                  ) : null}
                </ScoringLine>
                <PercentWrapper>
                  <TotalPercent>{totalScoring}/5</TotalPercent>
                </PercentWrapper>
              </TotalContainer>
              {subratings?.map((item) => (
                <TooltipContainer key={item?.key}>
                  <TooltipTitle>
                    <span>{item.localizedName} </span>
                  </TooltipTitle>
                  <ScoringLine>
                    {item.image ? (
                      <Image
                        src={item?.image ?? ''}
                        alt='playstoreqr'
                        width={50}
                        height={10}
                      />
                    ) : (
                      <PointBar
                        value={item.value || 0}
                        maxValue={5}
                        width='50px'
                      />
                    )}
                  </ScoringLine>
                  <PercentWrapper>
                    <Percent>
                      {item.value}/<TotalPercent>5</TotalPercent>
                    </Percent>
                  </PercentWrapper>
                </TooltipContainer>
              ))}
              <Separate />
              <NoteWrapper>
                {provider === RatingProviderType.TRIP_ADVISOR ? (
                  <Image
                    src='/static/images/tripadvisor.png'
                    width={18}
                    height={12}
                    alt='tripadvisor'
                  />
                ) : null}

                <Note>
                  {provider === RatingProviderType.TRIP_ADVISOR
                    ? 'Otel puan ve yorumları Tripadvisor’dan alınmaktadır.'
                    : 'Otel puanı ve en güncel 100 yorum hiçbir müdahale olmaksızın Expedia’dan alınmaktadır.'}
                </Note>
              </NoteWrapper>
            </>
          }
        >
          <ContainerHead>
            <WrapperTitle>
              <Typography variant='caption3' weight='Regular'>
                Misafir Puanı
              </Typography>
              <Typography variant='caption3' weight='Bold'>
                {getRating(totalScoring ?? 0)}
              </Typography>
            </WrapperTitle>
            <ContainerBox>
              <SpanWrapper colorRating={getRatingAboveFour(totalScoring ?? 0)}>
                <DivSpan>
                  <Span>{totalScoring}/5</Span>
                </DivSpan>
              </SpanWrapper>
            </ContainerBox>
          </ContainerHead>
        </Tooltip>
      </Wrapper>
    </Container>
  );
};
export default ScoringBanner;
